import type { ReactNode } from 'react';

export const symbol_variables: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-310v-340q0-12.75 8.63-21.38Q137.25-680 150-680h660q12.75 0 21.38 8.62Q840-662.75 840-650v340q0 12.75-8.62 21.37Q822.75-280 810-280H150q-12.75 0-21.37-8.63Q120-297.25 120-310Zm60-30h600v-280H180v280Zm0 0v-280 280Z"
		/>
	</svg>
);
